import React from 'react';
import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  Editing,
  Lookup,
  Popup,
  Form
} from 'devextreme-react/data-grid';
import { dataGridErrorHandling } from '../../../utils/errorHandling';
import { razzeDataSource } from '../../../datasources/razzeDataSource';
import { TipiAnimaliDataSource } from '../../../datasources/tipiAnimaliDataSource';
import { Item } from 'devextreme-react/form';

export default function Task() {
  return (
    <React.Fragment>
      <h2 className={'content-block'}>Tipi animali</h2>

      <DataGrid
        className={'dx-card wide-card'}
        //dataSource={dataSource as any}
        dataSource={TipiAnimaliDataSource()}
        showBorders={false}
        focusedRowEnabled={true}
        defaultFocusedRowIndex={0}
        columnAutoWidth={true}
        columnHidingEnabled={true}
        onRowUpdating={function (e) { e.newData = Object.assign({}, e.oldData, e.newData)}}
        onDataErrorOccurred={dataGridErrorHandling}
      >
        <Editing
          mode="popup"
          allowUpdating={true}
          allowAdding={true}
          allowDeleting={true}>
          <Popup title="Tipo animale" showTitle={true} />
          <Form>
            <Item dataField="codice"/>
            <Item dataField="descrizione"/>
            <Item dataField="maschio"/>
            <Item dataField="idRazza" editorType='dxSelectBox'/>
          </Form>
        </Editing>
        <Paging defaultPageSize={10} />
        <Pager showPageSizeSelector={true} showInfo={true} />
        <FilterRow visible={true} />

        <Column type='buttons' />
        <Column dataField={'id'} width={90} hidingPriority={2} allowEditing={false} visible={false} sortOrder="asc" />
        <Column dataField={'codice'} />
        <Column
          dataField={'descrizione'}
          sortIndex={0} 
          // width={190}
          caption={'Descrizione'}
          hidingPriority={8}
        />
         <Column dataField={'maschio'} />
         <Column dataField={'idRazza'} caption='Razza' >
          <Lookup dataSource={razzeDataSource} valueExpr="id" displayExpr="descrizione"  />
        </Column>
      </DataGrid>
    </React.Fragment>
)}
